module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadingData) ? _c('Loader') : _vm._e(), _c('div', [_c('button', {
    staticClass: "btn btn-primary float-right",
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下載目前報告")]), _vm._m(0), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medName),
      expression: "medName"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入流水號, 車號或日期"
    },
    domProps: {
      "value": (_vm.medName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medName = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('hr'), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/drug-storage-summary/"),
      "data-path": "",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "perPage": 30,
      "row-class": _vm.onRowClass,
      "css": _vm.boostrapCss,
      "detail-row-component": "adc-drug-detail-drug-storage",
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "total_amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.rowData.total_amount))])]
      }
    }])
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('kbd', [_vm._v("區間測速資訊")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476d7268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/DrugList.vue
// module id = 1461
// module chunks = 1